import { render, staticRenderFns } from "./InboxSession.vue?vue&type=template&id=0703b6b8&scoped=true"
import script from "./InboxSession.vue?vue&type=script&lang=js"
export * from "./InboxSession.vue?vue&type=script&lang=js"
import style0 from "./InboxSession.vue?vue&type=style&index=0&id=0703b6b8&prod&lang=scss&scoped=true"
import style1 from "./InboxSession.vue?vue&type=style&index=1&id=0703b6b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0703b6b8",
  null
  
)

export default component.exports